import Vue from 'vue'


// 获取某个特定园区的指定用户类型、指定作用终端、指定作用模块的UI配置
export const getUIConfig = async function(params = {}, config = {}) {
  config.params = params;
  const result = await Vue.http.get('/lw-garden-personalized-configuration/configurable-ui-item/batch-detail/V1',config)
  return result
}